import type { FC } from 'react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import GenericErrorImg from '../../../FeedError/GenericErrorImg.svg';

export const i18n = defineMessages({
	errorMessage: {
		id: 'feed.card.activity.error.generic.message',
		defaultMessage: 'We couldn’t load the recent actions',
		description:
			"error message that is presented when a data error stops us from rendering any useful information in the 'recent updates' list",
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	marginBottom: token('space.150', '12px'),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img<{ height: number }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: `${(props) => props.height}px`,
	marginBottom: token('space.200', '16px'),
});

export const AllActivityError: FC = () => {
	return (
		<Wrapper>
			<Image height={65} src={GenericErrorImg} />
			<FormattedMessage {...i18n.errorMessage} />
		</Wrapper>
	);
};
